import React, { useState } from 'react'
import SearchForPlacas from 'src/pages/ReportsPages/SearchTablesPage/SearchForPlacas'
import swal from 'sweetalert'
import { swalMessages } from '../../constants'
import {
  postDocument,
  postPlaca,
  postPoints,
} from '../../services/finderServices'

const SearchDocumentsContainer = () => {
  const [users, setUsers] = useState([])
  const [usersPlaca, setUsersPlaca] = useState([])
  const [points, setPoints] = useState([])

  /*= =======================================================================
  Get  handlePlaca
====================================================== ================== */

  const handlePlaca = async (params) => {
    setUsers([])
    const { data } = await postPlaca(params)
    if (data) {
      setUsersPlaca(data)
    } else {
      swal(swalMessages.NOT_FOUND)
    }
  }

  /*= =======================================================================
  Get  handleDocument
====================================================== ================== */

  const handleDocument = async (params) => {
    setUsersPlaca([])
    const { data } = await postDocument(params)
    if (data) {
      setUsers(data)
    } else {
      swal(swalMessages.NOT_FOUND)
    }
  }

  /*= =======================================================================
  Get  handlePoins
====================================================== ================== */
  const handlePoins = async (params) => {
    setPoints([])
    const { data } = await postPoints(params)
    if (data) {
      setPoints(data)
      handleDocument(params)
    } else {
      swal(swalMessages.NOT_FOUND)
    }
  }

  const handlerSubmit = (value) => {
    const expresion = /[a-z]{3}[0-9]{2,3}[a-z]*/gi
    if (value.match(expresion)) {
      handlePlaca({ placa: value })
    } else {
      handlePoins({ cedulas: value })
    }
  }
  console.log('points Documents Container', points)

  return (
    <SearchForPlacas
      users={users}
      points={points}
      usersPlaca={usersPlaca}
      handlerSubmit={handlerSubmit}
    />
  )
}

export default SearchDocumentsContainer
